var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags_view"},[_c('el-breadcrumb',{staticClass:"breadcrumb",attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.Breadcrumb),function(item){return _c('el-breadcrumb-item',{key:item.path,staticClass:"title",attrs:{"to":item.path}},[_vm._v(" "+_vm._s(item.meta.title)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }